import { useEffect } from "react";
import theme from "../../../../theme";

type CustomCircleProps = {
  map: google.maps.Map | null;
  center: google.maps.LatLngLiteral;
  radius: number;
};

const CustomCircle = ({ map, center, radius }: CustomCircleProps) => {
  useEffect(() => {
    if (!map) return;

    const options = {
      strokeColor: theme.palette.primary.main,
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillOpacity: 0.03,
    };

    const circle = new google.maps.Circle({
      map,
      center,
      radius,
      ...options,
    });

    return () => {
      circle.setMap(null);
    };
  }, [map, center, radius]);

  return null;
};

export default CustomCircle;
